
import {View} from 'backbone';
import template from 'common-views/show-behavior-list.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import util from '../../service/util/Util.js';
import listService from 'ListService';

class ShowBehaviorListModalView extends View {
    initialize(opts){
        super.initialize(opts);
        $('body').append(this.$el);
    }

    exportCSV(){
        console.log('Exporting to CSV...');
        let currentItems=this.model.get('items');
        console.log("Current Items",currentItems);

        let header = ['Parent', 'Owner', 'Behavior'];

        util.generateCSV(currentItems, header);
    }

    selectBehaviorInstance(id, selectedCommand = '', objectId = '', behaviorKey = '') {
        var instance = listService.getBehaviorInstance(id);
        if (instance) {
            if (listService._mainKind === 'B') {                
                behaviorHelperService.showBehaviorInstance(id);
            } else {
                let command = '';
                if (selectedCommand) {
                    command = '/' + selectedCommand;
                }
                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('behaviors/' + instance.get('ownerId') + '/' + instance.get('behaviorKey') + command);
            }
        } else if (objectId) {
           let control = listService.getObject(objectId);
           if (!control) {
               control = listService.getPage(objectId);
           }

           listService.linkClicked = true;
           Backbone.history.loadUrl(`behaviors/${objectId}/${behaviorKey}`);
           listService.clearSelected();
       }

    }

    render(){
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
             $('a.item-behavior').off('click').on('click',  (ev)=> {
            var id = ev.currentTarget.attributes["data-id"].value;
            this.closeModal();
            this.selectBehaviorInstance(id);
        });
            this.delegateEvents();

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 225,
                width: 400,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Export to CSV',
                        'class':'btn-select-item',
                        disabled: false,
                        click: () => {
                            resolve(this.exportCSV());
                            this.closeModal();
                        }
                    },
                    {
                        text: 'Ok',
                        'class':'btn-select-item',
                        disabled: false,
                        click: () => {
                            resolve();
                            this.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve();
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    this.bindEvents();
                },
                close: () => {
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }

    bindEvents(){
        //$('#dialog').find('.item').click(e => this.itemSelected(e));
    }
    unbindEvents(){
        //$('#dialog').find('.item').unbind();
    }

    closeModal(){
        $( constants.DIALOG_ID ).dialog("destroy");
        this.remove();
    }
}

export default ShowBehaviorListModalView;